import { useContext } from 'react';
import { FlagSet, FlagsContext } from '../context/FlagContext';

const handler = {
  get(target: FlagSet, name: string) {
    const value = target[name];
    if (value === undefined) {
      console.warn(
        `You haven't set the flag ${name} in the ${process.env.ENVIRONMENT} env`,
      );
    }
    return value;
  },
};

export function useFlags<T extends FlagSet>() {
  const flags = useContext(FlagsContext);
  if (typeof window !== 'undefined' && window.Proxy) {
    return new Proxy(flags, handler) as T;
  }
  return flags as T;
}
